import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from "./actions";

// Initial state
const initialState = {
    isAuthenticated: false,
    user: null,
};

// Reducer function
export function auth(state = initialState, action) {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return { ...state, isAuthenticated: true, user: action.payload };
        case LOGOUT_SUCCESS:
            return { ...state, isAuthenticated: false, user: null };
        default:
            return state;
    }
};
